module.exports = __webpack_public_path__ + "static/media/android.e2b82647.pdf";